import React, { useState, useEffect } from 'react';
import { UseAxios } from '../Server-Api-Instance.js';
import {
  TextField, Box, Grid, Button, MenuItem, Table, TableHead,
  TableBody, TableCell, TableContainer, TableRow, Paper
} from '@mui/material';
import { ThemeProvider } from '@mui/material';
import theme from '../Shared/theme.js';
import '../Shared/CommonStyle.css';
import { TableFooter } from '@mui/material';
import { Select,  FormControl, InputLabel } from '@mui/material';

const currentYear = new Date().getFullYear();
const years = Array.from({ length: currentYear - 2021 + 1 }, (_, i) => currentYear+2 - i);

const DestinationTable = ({ username }) => {
  const [data, setData] = useState([]);
  const [month, setMonth] = useState('All');
  const [year, setYear] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(false);

  const months = [
    { label: 'All Months', value: 'All' },
    { label: 'January', value: 1 }, { label: 'February', value: 2 },
    { label: 'March', value: 3 }, { label: 'April', value: 4 },
    { label: 'May', value: 5 }, { label: 'June', value: 6 },
    { label: 'July', value: 7 }, { label: 'August', value: 8 },
    { label: 'September', value: 9 }, { label: 'October', value: 10 },
    { label: 'November', value: 11 }, { label: 'December', value: 12 },
  ];

  const fetchData = async () => {
    if (!username) return;
  
    setLoading(true);
    try {
      const axios = UseAxios(false);
  
      const params = {
        username,
        year,
        month: month === 'All' ? 'All' : parseInt(month),
      };
  
      const response = await axios.get(`/Destination-chart`, { params });
      setData(response.data || []);
    } catch (error) {
      console.error('Error fetching data:', error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    fetchData();
  }, [username]);

  const handleFilter = () => {
    fetchData();
  };


// Utility: group rows by Destination
const groupByDestination = (rows) => {
  const grouped = {};

  rows.forEach((row) => {
    if (!grouped[row.Destination]) {
      grouped[row.Destination] = {
        Destination: row.Destination,
        TotalBookings: 0,
        TotalPassengers: 0,
        TotalDuration: 0,
        TotalSellAmount: 0,
        AgencyCommission: 0,
      };
    }

    grouped[row.Destination].TotalBookings += row.TotalBookings || 0;
    grouped[row.Destination].TotalPassengers += row.TotalPassengers || 0;
    grouped[row.Destination].TotalDuration += ((row.TotalDuration || 0) / (row.TotalBookings || 1));
    grouped[row.Destination].TotalSellAmount += row.TotalSellAmount || 0;
    grouped[row.Destination].AgencyCommission += row.AgencyCommission || 0;
  });

  return Object.values(grouped);
};

const formatCurrency = (value) => {
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 2,
  }).format(value || 0).replace('£', '£');
};

  return (
    <ThemeProvider theme={theme}>
      <Box className="header">
        <Box className="heading-box">TOP DESTINATION DETAILS</Box>

        <Grid container spacing={2} alignItems="center" justifyContent="center">

          <Grid item xs={6} sm={3}>
          <FormControl fullWidth>
  <InputLabel id="departure-year-label">Departure Year</InputLabel>
  <Select
    labelId="departure-year-label"
    value={year}
    label="Departure Year"
    onChange={(e) => setYear(e.target.value)}
  >
    {years.map((yr) => (
      <MenuItem key={yr} value={yr}>
        {yr}
      </MenuItem>
    ))}
  </Select>
</FormControl>
          </Grid>
          <Grid item xs={6} sm={3}>
            <TextField
              label="Departure Month"
              select
              fullWidth
              value={month}
              onChange={(e) => setMonth(e.target.value)}
              InputLabelProps={{ shrink: true }}
            >
              {months.map((m) => (
                <MenuItem key={m.value} value={m.value}>
                  {m.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>


          <Grid item xs={12} sm={3}>
            <Button  className="fetch-button" 
              variant="contained"
              fullWidth
              style={{ backgroundColor: '#BE9F55', color:'#fff', marginTop: '4px' }}
              onClick={handleFilter}
            >
              SUBMIT
            </Button>
          </Grid>
        </Grid>

        {loading ? (
          <Box className="loading-message">Loading data...</Box>
        ) : (
          <Box sx={{ border: '1px solid #ccc', borderRadius: '8px', overflow: 'hidden' }}>
            <TableContainer sx={{ maxHeight: 460 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow >
                    <TableCell sx={{ backgroundColor: '#bea05a', color: 'white', fontWeight: 'bold' }}>Destination</TableCell>
                    <TableCell align="right" sx={{ backgroundColor: '#bea05a', color: 'white', fontWeight: 'bold' }}>Total Passengers</TableCell>
                    <TableCell align="right" sx={{ backgroundColor: '#bea05a', color: 'white', fontWeight: 'bold' }}>Total Bookings</TableCell>
                    <TableCell align="right" sx={{ backgroundColor: '#bea05a', color: 'white', fontWeight: 'bold' }}>Avg Duration</TableCell>
                    <TableCell align="right" sx={{ backgroundColor: '#bea05a', color: 'white', fontWeight: 'bold' }}>Sell Amount</TableCell>
                    <TableCell align="right" sx={{ backgroundColor: '#bea05a', color: 'white', fontWeight: 'bold' }}>Agency Commission</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center" sx={{ color: 'red' }}>
                        No data available for selected period
                      </TableCell>
                    </TableRow>
                  ) : (
                    groupByDestination(data).map((row, idx) => (
                      <TableRow key={idx}>
                        <TableCell>{row.Destination}</TableCell>
                        <TableCell align="right">{row.TotalPassengers}</TableCell>
                        <TableCell align="right">{row.TotalBookings}</TableCell>
                        <TableCell align="right">{row.TotalDuration.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) || 0}</TableCell>
                        <TableCell align="right">{formatCurrency(row.TotalSellAmount)}</TableCell>
                        <TableCell align="right">{formatCurrency(row.AgencyCommission)}</TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
                {data.length > 0 && (
                  <TableFooter>
                    <TableRow className="sticky-footer"  >
                      <TableCell style={{ fontSize: '14px', fontWeight: 'bold' }}>Total</TableCell>
                      <TableCell align="right" style={{ fontSize: '13px', fontWeight: 'bold' }}>
                        {data.reduce((sum, row) => sum + (row.TotalPassengers || 0), 0)}
                      </TableCell>
                      <TableCell align="right" style={{ fontSize: '13px', fontWeight: 'bold' }}>
                        {data.reduce((sum, row) => sum + (row.TotalBookings || 0), 0)}
                      </TableCell>
                      <TableCell align="right" style={{ fontSize: '13px', fontWeight: 'bold' }}>
                        {(data.reduce((sum, row) => sum + (row.TotalDuration || 0), 0) / (data.reduce((sum, row) => sum + (row.TotalBookings || 0), 0) || 1)).toFixed(2)}
                      </TableCell>
                      <TableCell align="right" style={{ fontSize: '13px', color: 'blue', fontWeight: 'bold' }}>
                        {formatCurrency(data.reduce((sum, row) => sum + (row.TotalSellAmount || 0), 0))}
                      </TableCell>
                      <TableCell align="right" style={{ fontSize: '13px', color: 'green', fontWeight: 'bold' }}>
                        {formatCurrency(data.reduce((sum, row) => sum + (row.AgencyCommission || 0), 0))}
                      </TableCell>
                    </TableRow>
                  </TableFooter>
                )}
              </Table>

            </TableContainer>
          </Box>
        )}
      </Box>
    </ThemeProvider>
  );
};

export default DestinationTable;
